import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get, pad } from "lodash";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import "./ReportedGig.css";
import Overlay from "../../components/Overlay";
import { Modal } from "../../components/Modal";
import { extractDate, subadminAccessChange } from "../../utils/functions";
import * as XLSX from 'sheetjs-style';
import { saveAs } from "file-saver";
import ReactReadMoreReadLess from "react-read-more-read-less";

// Mui & material UI
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import SearchBar from "material-ui-search-bar";
import Pagination from '@mui/material/Pagination';
import { makeStyles } from "@material-ui/core/styles";
import { TextField, Popover, Box } from "@mui/material";
import PaginationItem from '@mui/material/PaginationItem';

import {
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination
} from "@material-ui/core";

// icons 
import { SlLockOpen } from "react-icons/sl";
import { MdBlockFlipped } from "react-icons/md";
import { HiOutlineBars3BottomLeft } from "react-icons/hi2";
import { RxCross2, RxCrossCircled, RxFontStyle } from "react-icons/rx";
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";
import { AiOutlineDownload } from "react-icons/ai";
import { FiPlusCircle } from "react-icons/fi";
import { LuPencilLine } from "react-icons/lu";
import { FiEye } from "react-icons/fi";

import EyeIcon from "../../assets/images/eye-tick.png";
import UserIcon from "../../assets/images/users-check.png";
import unblock from "../../assets/images/unblock.png";
import block from "../../assets/images/block.png";

// Elements

import {
    DashboardContainer,
    DashboardWrapper,
    DashboardHeading,
    SearchFilterContainer,
    DashHeading,
    Button,
    DeleteButton,
    ProfileDetailForm,
    SelectedColumnContainer,
} from "./ReportedGigElement";
import zIndex from "@material-ui/core/styles/zIndex";
import NoResults from "../../components/NoResult";


const useStyles = makeStyles((theme) => ({
    table: {
        borderCollapse: 'separate',
        borderSpacing: '0 6px', // adds vertical spacing between rows
    },
    tableMainContainer: {
        maxHeight: "65vh",
        overflowX: "auto",
        overflowY: "auto",
        borderTopLeftRadius: "4px",
        borderTopRightRadius: "4px",

        // border: "1px solid rgba(17, 153, 38, 0.20)",

        // Optional scrollbar customization
        '&::-webkit-scrollbar': {
            height: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#5088FB',     // Scrollbar color
            borderRadius: '4px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
        },
    },
    tableHeadingRow: {
        position: "sticky", // Make header sticky
        top: 0, // Stick to the top
        zIndex: 1, // Ensure it appears above other rows
        background: "#FFFFFF", // Header background color
        // border: "1px solid rgba(17, 153, 38, 0.20)",

    },
    tableBodyRow: {
        background: "#FFFFFF",
        // border: "1px solid rgba(17, 153, 38, 0.20)",

        "&:hover": {
            backgroundColor: "#f5f5f5",
        },
    },
    tableHeadingCell: {
        // padding: "0.5rem 1rem !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#1C2D28",
        fontWeight: "500",
        // border: "1px solid #D9E3D9",
        whiteSpace: "nowrap",
        background: "#FFFFFF",
        border: "none"
    },
    textMiddle: {
        padding: "0.3rem 1rem !important",
        verticalAlign: "middle !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#484848",
        fontFamily: "Roboto",
        fontWeight: "400",
        background: "#FFFFFF",
        border: "none"
    },
    tablePaginationStyle: {
        borderTop: "1px solid #0000001a",
        borderRadius: "0rem 0rem 0.4rem 0.4rem",
        overflowY: "hidden",
    },
    paginationContainer: {
        marginTop: "2rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
}));



const ReportedGig = ({ setUsers, userData }) => {
    const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

    const reportedGigManagementPermissions = adminData?.adminpermissions?.modules?.find(
        (module) => module.moduleName === "Reported Gig Management"
    )?.permissions || {};


    const canView = !!reportedGigManagementPermissions.view;
    const canAdd = !!reportedGigManagementPermissions.add;
    const canEdit = !!reportedGigManagementPermissions.edit;
    const canDelete = !!reportedGigManagementPermissions.delete;
    const canBlockUnblock = !!reportedGigManagementPermissions.blockUnblock;
    const canDownload = !!reportedGigManagementPermissions.download;

    const userManagementPermissions = adminData?.adminpermissions?.modules?.find(
        (module) => module.moduleName === "User Management"
    )?.permissions || {};

    const isSubAdmin = adminData?.userType === "subAdmin";

    // Check if view permissions in Gig Management are false
    const hasNoUserManagementPermissions = userManagementPermissions &&
        !userManagementPermissions.view

    const gigManagementPermissions = adminData?.adminpermissions?.modules?.find(
        (module) => module.moduleName === "Gigs Management"
    )?.permissions || {};

    const isSubAdminData = adminData?.userType === "subAdmin";

    // Check if view permissions in User Management are false
    const hasNoGigManagementPermissions = gigManagementPermissions &&
        !gigManagementPermissions.view



    const classes = useStyles();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [totalBlock, setTotalBlock] = useState()


    const [deleteModal, setDeleteModal] = useState(false);
    const [filterStatus, setFilterStatus] = useState("all");
    const [blockModal, setBlockModal] = useState(false);
    const [unBlockModal, setUnBlockModal] = useState(false);
    const [selectedGig, setSelectedGig] = useState(null);
    const [blockData, setBlockData] = useState()
    const [selectedGigId, setSelectedGigId] = useState(null);




    // For Pagination
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalDocs, setTotalDocs] = useState(0);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(1); // Reset to the first page when rows per page change
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage); // Update page and trigger data fetch
    };


    // For Select checkbox
    const [selectedRows, setSelectedRows] = useState([]);

    useEffect(() => {
        if (tableData.length === 0) {
            setSelectedRows([]);
        }
    }, [tableData]);

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedRows(tableData.map((item) => item._id));
        } else {
            setSelectedRows([]);
        }
    };

    const handleSelectRow = (id) => {
        const newSelectedRows = selectedRows.includes(id)
            ? selectedRows.filter((rowId) => rowId !== id)
            : [...selectedRows, id];
        setSelectedRows(newSelectedRows);
    };

    const handleClearSelection = () => {
        setSelectedRows([]);
    };

    const [anchorEl, setAnchorEl] = useState(null);



    const handleFilterClick = (event) => {
        setAnchorEl(event.currentTarget); // Open the filter popover
    };

    const handleClose = () => {
        setAnchorEl(null); // Only close the popover without resetting
    };



    const open = Boolean(anchorEl);
    const id = open ? "filter-popover" : undefined;

    // For Search functionality
    const [searchTerm, setSearchTerm] = useState("");

    function myDeb(call, d = 1000) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                call(...args);
            }, d);
        };
    }

    const SearchAccountManagement = myDeb((search) => {
        setSelectedRows([]);
        setSearchTerm(search);
        setPage(1); // Reset to the first page on search
    });

    const cancelSearch = () => {
        setSearchTerm("");
        setPage(1); // Reset to the first page when search is canceled
    };




    // Get user data
    useEffect(() => {
        gigReport(page);

    }, [page, rowsPerPage, searchTerm, filterStatus]);

    const gigReport = async (currentPage) => {
        setIsLoading(true);
        setTotalDocs(0);

        try {
            const { data } = await axios.post(`private/getAllReportedGig?page=${currentPage}&limit=${rowsPerPage}&search=${searchTerm}`, {
                status: String(filterStatus), // Ensure status is a string
            });
            // console.log("data", data)

            setTableData(data?.data?.docs);
            setTotalDocs(data?.data?.totalDocs);
            setTotalBlock(data?.data?.docs[0]?.gigDetails);
            setBlockData(data?.data?.docs);
        } catch (error) {
            if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else if (error?.response?.status === 901) {
                subadminAccessChange(navigate);
                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });
            } else {
                console.log("error", error?.response)
            }
        } finally {
            setIsLoading(false);
        }
    };


    // Block unblock functionality
    const blockUnblock = async (id) => {
        try {
            const response = await axios.get(`/private/gigs/blockUnBlock/${id}`);

            toast.success(response.data.message, {
                position: "top-right",
            });
            gigReport(page);
        } catch (error) {

            if (error.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                toast.error(error.response.data?.message, {
                    position: "top-right",
                });
                navigate("/");
            } else {
                toast.error("Something went wrong", {
                    position: "top-right",
                });
            }
        }
    };





    return (
        <>
            <DashboardContainer>
                <DashboardWrapper>
                    <ProfileDetailForm>
                        <DashboardHeading>
                            Reported Gig Management
                        </DashboardHeading>

                        <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginTop: "0.5rem" }}>
                            <SearchBar
                                style={{
                                    minWidth: "25rem",
                                    height: "38px",
                                    borderRadius: "20px",
                                    backgroundColor: "#F8F9FB",
                                    color: "#212121",
                                    fontStyle: "Italic",
                                    fontWeight: 300,
                                    fontSize: "15px",
                                    fontFamily: "Roboto",
                                }}
                                className={"heightfix"}
                                onChange={(e) => {
                                    SearchAccountManagement(e);
                                }}
                                onCancelSearch={cancelSearch}
                                placeholder="Search By Gig Id and Gid Title"
                                inputProps={{ maxLength: 50 }}
                            />
                        </div>


                        {selectedRows.length > 0 && (
                            <SelectedColumnContainer>
                                <DeleteButton
                                    type="button"
                                    className="buttonWidthResponsive"
                                    onClick={() => {
                                        setDeleteModal(true);
                                    }}
                                >
                                    Delete
                                </DeleteButton>
                                <div className="column-selected">{selectedRows.length} Selected</div>
                                <div
                                    className="container-clear-selection"
                                    onClick={handleClearSelection}
                                >
                                    <RxCrossCircled />
                                    <span className="column-selected">Clear Response</span>
                                </div>
                            </SelectedColumnContainer>
                        )}

                        <TableContainer className={classes.tableMainContainer} style={{ marginTop: "0.5rem" }}>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow className={classes.tableHeadingRow}>
                                        {/* <TableCell className={classes.tableHeadingCell}>
                                            <Checkbox
                                                style={{ padding: "2px" }}
                                                indeterminate={selectedRows.length > 0 && selectedRows.length < tableData.length}
                                                // checked={selectedRows.length > 0 && selectedRows.length === tableData.length}
                                                checked={tableData.length > 0 && tableData.every((item) => selectedRows.includes(item._id))}
                                                onChange={handleSelectAll}
                                                color="primary"
                                                disabled={!canDelete && adminData?.userType == "subAdmin"} // Disable if canDelete is false
                                            />
                                        </TableCell> */}
                                        <TableCell className={classes.tableHeadingCell}>
                                            S.No
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Action
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Gig ID
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            <div style={{ textAlign: "left", marginLeft: "2rem" }}>
                                                Gig Title
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            <div style={{ textAlign: "left", marginLeft: "2rem" }}>
                                                Last Reported Reason
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            User Type
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            <div style={{ textAlign: "left", marginLeft: "2rem" }}>
                                                Last Reported User Name
                                            </div>
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Last Reported Date & Time
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                {tableData && tableData.length > 0 ? (
                                    <>
                                        <TableBody>
                                            {tableData.map((user, index,) => (
                                                <TableRow className={classes.tableBodyRow} key={user._id}>
                                                    {/* <TableCell className={classes.textMiddle}>
                                                        <Checkbox
                                                            style={{ padding: "2px" }}
                                                            checked={selectedRows.includes(user._id)}
                                                            onChange={() => handleSelectRow(user._id)}
                                                            color="primary"
                                                            disabled={!canDelete && adminData?.userType == "subAdmin"} // Disable if canDelete is false
                                                        />
                                                    </TableCell> */}
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{index + 1 + rowsPerPage * (page - 1)}</div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem", fontSize: "1.1rem", cursor: "pointer", color: "#5088FB" }}>
                                                            <FiEye
                                                                title="View All Users Reported this Gig"
                                                                onClick={() => navigate(`/reportUserList/${user.gigId}`, { state: { from: "reportedGigManagement" } })}
                                                                style={{ cursor: 'pointer' }}
                                                            />

                                                            {!(!canBlockUnblock && adminData?.userType === "subAdmin") && (


                                                                get(user, 'gigDetails.isBlocked') == false ? (
                                                                    <MdBlockFlipped
                                                                        title="Block Gig"
                                                                        onClick={() => {
                                                                            setSelectedGigId(user.gigDetails._id);  // ← Set clicked gig ID
                                                                            setBlockModal(true);
                                                                        }}
                                                                        style={{ color: 'red', cursor: 'pointer' }}
                                                                    />
                                                                ) : (
                                                                    <SlLockOpen
                                                                        title="Unblock Gig"
                                                                        onClick={() => {
                                                                            setSelectedGigId(user.gigDetails._id);  // ← Set clicked gig ID
                                                                            setUnBlockModal(true);
                                                                        }}
                                                                        style={{ cursor: 'pointer' }}
                                                                    />
                                                                )
                                                            )}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{
                                                            textDecoration: "underline",
                                                            color: "#5088FB",
                                                            cursor: "pointer"
                                                        }}
                                                            // onClick={() => navigate(`/gigOverview/${totalBlock._id}`,
                                                            //     { state: { from: "reportedGigManagement" } })}

                                                            onClick={
                                                                !(isSubAdminData && hasNoGigManagementPermissions)
                                                                    ? () => navigate(`/gigOverview/${totalBlock._id}`, {
                                                                        state: { from: "reportedGigManagement" },
                                                                    })
                                                                    : undefined
                                                            }
                                                        >
                                                            {(get(user, "gigDetailId", "---"))}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>

                                                        <div style={{ textAlign: "left", marginLeft: "2rem" }}>
                                                            {get(user, "gigDetails.gigTitle", "---")}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{ textAlign: "left", marginLeft: "2rem" }}>
                                                            <ReactReadMoreReadLess
                                                                charLimit={30}
                                                                readMoreText={"Read more"}
                                                                readLessText={"Read less"}
                                                                readMoreStyle={{ color: "blue", cursor: "pointer", fontSize: "12px" }}
                                                                readLessStyle={{ color: "blue", cursor: "pointer", fontSize: "12px" }}
                                                            >
                                                                {get(user, "gigReportReason", "---")}
                                                            </ReactReadMoreReadLess>
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{(get(user, "gigDetails.gigUserType", "N/A"))}</div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div
                                                            style={{ textDecoration: "underline", color: "#5088FB", cursor: "pointer", textAlign: "left", marginLeft: "2rem" }}
                                                            onClick={
                                                                !(isSubAdmin && hasNoUserManagementPermissions)
                                                                    ? () => navigate(`/userDetails/${user.userId}`, {
                                                                        state: { from: "reportedGigManagement" },
                                                                    })
                                                                    : undefined
                                                            }
                                                        // onClick={() => navigate(`/userDetails/${user.userId}`,
                                                        //     { state: { from: "reportedGigManagement" } })}
                                                        >
                                                            {get(user, "userName", "---")}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{extractDate(get(user, "createdAt", "---"))}</div>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </>
                                ) : (
                                    <>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={13} align="center" style={{ padding: "2rem", border: "none" }}>
                                                    <DashHeading style={{ textAlign: "center", padding: "2rem" }}><NoResults /></DashHeading>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>

                                    </>
                                )}
                            </Table>
                        </TableContainer>
                        {(tableData && tableData.length > 0) && (
                            <>
                                <Stack spacing={2} className={classes.paginationContainer}>
                                    <Pagination
                                        count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                                        page={page}
                                        onChange={(event, value) => handleChangePage(event, value)} // Update page
                                        renderItem={(item) => (
                                            <PaginationItem
                                                slots={{ previous: HiMiniArrowLeft, next: HiMiniArrowRight }}
                                                {...item}
                                            />
                                        )}
                                    />
                                </Stack>
                            </>
                        )}
                    </ProfileDetailForm>
                </DashboardWrapper>
            </DashboardContainer>


            {/* Modal for Block User  */}
            < Modal
                maxWidth="lg"
                width="360px"
                RoundedCorners={true}
                isOpen={blockModal}
                onClose={() => {
                    setBlockModal(false);
                }}
                backgroundModal={false}
                backgroundModalContent={false}
                title={
                    <div div >
                        <div className="d-flex align-items-center justify-content-end">
                            <RxCross2 style={{ cursor: "pointer" }} onClick={() => setBlockModal(false)} />
                        </div>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "10px" }}>
                            <img src={block} style={{ height: "3.5rem" }} />
                        </div>
                        <div className="block-header" style={{ textAlign: "center" }}>Are you sure you want to block this gig ?</div>

                    </div >
                }
                content={
                    <>
                        <div className="logout-button-group">
                            <div
                                className="cancel-button"
                                onClick={() => {
                                    setBlockModal(false);
                                }}
                            >
                                Cancel
                            </div>
                            <div
                                className="logout-button"
                                style={{ background: "#5588FB", cursor: "pointer" }}
                                // onClick={() => {
                                //     setBlockModal(false);
                                //     blockUnblock(totalBlock?._id)
                                // }}
                                onClick={() => {
                                    setBlockModal(false);
                                    blockUnblock(selectedGigId); // ← Use selectedGigId here
                                    setSelectedGigId(null);
                                }}

                            >
                                Yes
                            </div>

                        </div>
                    </>
                }
            />

            {/* Modal for UnBlock User  */}
            < Modal
                maxWidth="lg"
                width="360px"
                RoundedCorners={true}
                isOpen={unBlockModal}
                onClose={() => {
                    setUnBlockModal(false);
                }}
                backgroundModal={false}
                backgroundModalContent={false}
                title={
                    <div div >
                        <div className="d-flex align-items-center justify-content-end">
                            <RxCross2 style={{ cursor: "pointer" }} onClick={() => setUnBlockModal(false)} />
                        </div>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "10px" }}>
                            <img src={unblock} style={{ height: "3.5rem" }} />
                        </div>
                        <div className="block-header" style={{ textAlign: "center" }}>Are you sure you want to Unblock this Gig ?</div>

                    </div >
                }
                content={
                    <>
                        <div className="logout-button-group">
                            <div
                                className="cancel-button"
                                onClick={() => {
                                    setUnBlockModal(false);
                                }}
                            >
                                Cancel
                            </div>
                            <div
                                className="logout-button"
                                style={{ background: "#5588FB", cursor: "pointer" }}
                                // onClick={() => {
                                //     setUnBlockModal(false);
                                //     blockUnblock(totalBlock?._id)
                                // }}
                                onClick={() => {
                                    setUnBlockModal(false);
                                    blockUnblock(selectedGigId); // ← Use selectedGigId here
                                    setSelectedGigId(null);
                                }}

                            >
                                Yes
                            </div>

                        </div>
                    </>
                }
            />


            {/* Modal for Delete User  */}
            {/* <Modal
                maxWidth="lg"
                width="360px"
                RoundedCorners={true}
                isOpen={deleteModal}
                onClose={() => {
                    setDeleteModal(false);
                }}
                backgroundModal={false}
                backgroundModalContent={false}
                title={
                    <div>
                        <div className="d-flex align-items-center justify-content-end">
                            <RxCross2
                                style={{
                                    cursor: "pointer",
                                }}
                                onClick={() => { setDeleteModal(false); }}
                            />
                        </div>
                        <p className="profile-section-text">Delete Word</p>
                        <div className="logout-header" style={{ paddingTop: "0px" }}>Are you sure you want to delete this Word? Please confirm.</div>
                    </div>
                }
                content={
                    <>
                        <div className="logout-button-group">
                            <div
                                className="cancel-button"
                                onClick={() => {
                                    setDeleteModal(false);
                                }}
                            >
                                Cancel
                            </div>
                            <div className="logout-button" style={{ background: "#5088FB" }} onClick={() => DeleteUser(null)}>
                                Yes
                            </div>
                        </div>
                    </>
                }
            /> */}
            {isLoading && <Overlay />}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        locationData: state.locations,
        defaultState: state.defaultState,
        sidebar: state.sidebar,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setUsers: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_USER,
                updatedUser: updatedValue,
            });
        },
        setDefaultState: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_DEFAULT,
                updateDefault: updatedValue,
            });
        },
        setSidebar: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_SIDEBAR,
                updateSidebar: updatedValue,
            });
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportedGig);





